import messages from '@sigma-frontend-libs/messages'

import settingsUser from './settingsUser'

const settingsUserLabels = Object.assign(
  settingsUser.labels,
  {
    sendings: {
      ...settingsUser.labels.sendings,
      sendernamesCheck: 'Message processing: Sender names',
      patternsCheck: 'Message processing: Patterns'
    }
  }
)

export default {
  title: 'Events history',

  labels: {
    eventsHistory: 'History of changes',
    type: 'Type',
    userId: 'User',
    entityId: 'Entity ID',
    service: 'Service',
    oldValues: 'Was',
    newValues: 'Became',
    author: 'Author',
    changesType: 'Type',
    created: 'Created',
    imported: 'Imported',
    compareId: 'ID of entity',
    permissionsUsers: 'User permission'
  },

  updatedValues: {
    ...messages.en.services,
    ...settingsUserLabels,

    value: 'Value',

    data: 'Data',
    isActive: 'Activate/Deactivate',
    state: 'State',
    startsAt: 'Starts at',
    updatedAt: 'Updated at',
    title: 'Title',
    serverId: 'Server',
    credentialsId: 'Credentials',
    comment: 'Comment',
    properties: 'Properties',
    replacements: 'Replacements of content',
    createdAt: 'Created at',
    deletedAt: 'Deleted at',

    type: 'Type',
    provider: 'Provider',
    name: 'Name',

    rules: 'Rules',

    description: 'Description',

    source: 'Source',
    ownerId: 'Owner',

    resellerId: 'Reseller',
    password: 'Password',
    referralCode: 'Referral code',
    sudo: 'Sudo',
    username: 'User name',

    amount: 'Amount',
    status: 'Status',
    TariffId: 'Tariff',

    listId: 'ListId',
    date: 'Date',
    email: 'Email',
    firstName: 'Name',
    gender: 'Gender',
    id: 'Id',
    lastName: 'Surname',
    middleName: 'Patronymic',
    phone: 'Phone',

    fallbacks: 'Fallbacks',
    payload: 'Payload',
    recipient: 'Recipient',

    meta: 'Meta',
    moderation: 'Moderation',

    conditions: 'Conditions',
    trafficType: 'Traffic type',

    records: 'Credentials',

    signer: 'Signer',
    contact: 'Contact',
    data: 'Data',
    legal: 'Legal entity',
    bank: 'Bank',
    tax: 'Taxes',
    address: 'Address',
    legalAddress: 'Legal address'
  },

  types: {
    created: 'Created',
    imported: 'Imported',
    updated: 'Updated',
    removed: 'Removed'
  },

  services: {
    ...messages.en.services,

    billingsUsers: 'Financial transaction',
    contactLists: 'Contact lists',
    settingsUserUsers: 'User settings',
    keywordLists: 'Keyword Lists',
    permissionsUsers: 'User permissions',
    tokensUsers: 'Token'
  },

  tooltips: {
    historyButton: 'View change history'
  }
}

